import {
  ROLE_PERMISSION_LIST_REQUEST,
  ROLE_PERMISSION_LIST_SUCCESS,
  ROLE_PERMISSION_LIST_FAIL,
  RESET_STATE_ROLE_PERMISSION,
  CREATE_ROLE_PERMISSION_REQUEST,
  CREATE_ROLE_PERMISSION_SUCCESS,
  CREATE_ROLE_PERMISSION_FAIL,
  DELETE_ROLE_PERMISSION_REQUEST,
  DELETE_ROLE_PERMISSION_SUCCESS,
  DELETE_ROLE_PERMISSION_FAIL
} from '../../constants/rolePermissions'

const initialState = {
  rolePermissions: [],
  pageable: {},
  loading: false,
  status: '',
  error: ''
}

const rolePermissionReducer = (state = initialState, action) => {
  switch (action.type) {
    // ** Section List Role Permission
    case ROLE_PERMISSION_LIST_REQUEST:
      return { ...state, loading: true }
    case ROLE_PERMISSION_LIST_SUCCESS:
      return { ...state, loading: false, rolePermissions: action.payload, pageable: action.pageable, error: ''}
    case ROLE_PERMISSION_LIST_FAIL:
      return { ...state, loading: false, error: action.payload, rolePermissions: [] }
    case CREATE_ROLE_PERMISSION_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_ROLE_PERMISSION_SUCCESS:
      const  rolePermissionData = [...state?.rolePermissions]
      const index = rolePermissionData.findIndex(rolePermission => rolePermission.id === action.payload.id)
      rolePermissionData[index].active = true

      return { ...state, loadingCreate: false, rolePermissions: rolePermissionData }
    case CREATE_ROLE_PERMISSION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_ROLE_PERMISSION_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_ROLE_PERMISSION_SUCCESS:
      const rolePermissionDataDelete = [...state?.rolePermissions]
      const indexDelete = rolePermissionDataDelete.findIndex(rolePermission => rolePermission.id === action.payload)
      rolePermissionDataDelete[indexDelete].active = false

      return { ...state, loadingDelete: false, rolePermissions: rolePermissionDataDelete }
    case DELETE_ROLE_PERMISSION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }

    // ** Section Reset State Role
    case RESET_STATE_ROLE_PERMISSION:
      return {
        ...state,
        loading: false,
        status: '',
        error: ''
      }

    default:
      return state
  }
}

export default rolePermissionReducer
